import API from '@/amplify/api';
import { atom } from 'recoil';

import localStorageUtil from '@/common/utils/localStorageUtil';

import {
    getAllProjectListInCorporation,
} from '@/service/projectService';
import {
    getProjectIdListUserIsB2CAtomSelector,
    getProjectInuseDetailSelector,
    getProjectListInCorporationByUserIdSelector,
    getViewKnowledgeProjectSelectedSelector
} from '../selector/projectSelector';
import { sortListByNameDictionaryASC } from '@/common/utils/utils';


/**
 * Create store save projectInuse detail state
 */
export const projectInuseDetailAtom = atom({
    key: 'projectInuseDetailAtom',
    default: getProjectInuseDetailSelector
});





/**
 * Get project list in corporation by userId
 */
export const projectListInCorporationByUserIdAtom = atom({
    key: 'projectListInCorporationByUserIdAtom',
    default: getProjectListInCorporationByUserIdSelector
});





/**
 * Get project list in corporation
 */
export const projectListInCorporationAtom = atom({
    key: 'projectListInCorporationAtom',
    default: [],
    effects: [
        async ({ setSelf, onSet, trigger, getPromise }) => {
            let corporationId = localStorageUtil.getAffiliationOrganization();
            let projectList = await getAllProjectListInCorporation(API, corporationId);
            projectList = sortListByNameDictionaryASC(projectList);
            setSelf(projectList);
        }
    ]
});


/**
 * projectIdListUserIsB2CAtom
 */
export const projectIdListUserIsB2CAtom = atom({
    key: 'projectIdListUserIsB2CAtom',
    default: getProjectIdListUserIsB2CAtomSelector,
});

export const viewKnowledgeProjectSelectedAtom = atom({
    key: 'viewKnowledgeProjectSelectedAtom',
    default: getViewKnowledgeProjectSelectedSelector,
})
